import * as React from "react";
import { Field } from "formik";
import Input from "components/bootstrap/Input";
const DescriptionFormGroup = () => /* @__PURE__ */ React.createElement(Field, { name: "description" }, ({ field: { value, onChange } }) => /* @__PURE__ */ React.createElement(
  Input,
  {
    type: "textarea",
    id: "description",
    label: "Description",
    required: true,
    onChange,
    help: "A description about the team",
    labelClassName: "col-sm-3",
    wrapperClassName: "col-sm-9",
    value: value != null ? value : ""
  }
));
export default DescriptionFormGroup;
